import { find } from 'lodash';

/**
 * Sets component data based on configuration object
 *
 * @param {Array} items Items to search for condition
 * @param   {object}  config  Object with configuration
 * @param {string} config.condition Condition to check for
 * @param {Array}  config.initialValue Base filters value
 * @param {Array} config.conditionMetValue Value of filters when condition is met
 * @returns {Array} Array with filters
 */
export const getInitialFilters = (items, {
    condition,
    conditionMetValue,
    initialValue = [],
}) => {
    if (! items) {
        return;
    }

    const hasAdditionalFilters = !! find(items, [condition, true]);

    return hasAdditionalFilters ? conditionMetValue : initialValue;
};

/**
 * Phrase filter
 *
 * @param   {Array}         items       Items to filter
 * @param   {Array|string}  properties  Object properties
 * @param   {string}        phrase      Search phrase
 *
 * @returns  {Array}                    Filtered array
 */
export const phraseFilter = (items, properties, phrase) => {
    properties = Array.isArray(properties) ? properties : [properties];
    phrase = phrase.toLowerCase();

    return items.filter(item =>
        properties.reduce((result, property) => {
            const value = (item[property] ?? '').toLowerCase();

            return result || value.includes(phrase);
        },
        false)
    );
};

/**
 * Featured filter
 *
 * @param   {Array}  filters  Array with filters
 * @param   {Array}  items    Array with items to filer
 *
 * @returns  {Array}           Filtered items
 */
export const featuredFilter = (filters, items) => (filters.includes('featured'))
    ? items.filter(item => item.featured)
    : items;

/**
 * Shows filter
 *
 * @param   {Array}  filters  Array with filters
 * @param   {Array}  items    Array with items to filer
 *
 * @returns  {Array}           Filtered items
 */
export const showsFilter = (filters, items) => items.filter(
    item => filters.includes(item.isPro ? 'pro' : 'free')
);
